import { CopyOutlined } from "@ant-design/icons";
import { Tooltip, message } from "antd";
import { useTranslation } from "react-i18next";

interface DisplayIdProps {
    value?: string | null;
    className?: string;
}

// Renders a task/milestone/inchstone display id (e.g. "TRV1000042") — always
// monospace and never truncated per the display-id guide's rendering rules.
// Old rows have no id, so this renders nothing rather than the string "null".
export const DisplayId = ({ value, className }: DisplayIdProps) => {
    const { t } = useTranslation();
    if (!value) return null;

    const handleCopy = (e: React.MouseEvent) => {
        e.stopPropagation();
        navigator.clipboard
            .writeText(value)
            .then(() => message.success(t("projectManagement:displayId.copied", { value })))
            .catch(() => message.error(t("projectManagement:displayId.copyFailed")));
    };

    return (
        <Tooltip title={t("projectManagement:displayId.copyTooltip")}>
            <span
                onClick={handleCopy}
                className={`inline-flex items-center gap-1 font-mono tracking-wide cursor-pointer hover:underline whitespace-nowrap ${className ?? ""}`}
            >
                {value}
                <CopyOutlined style={{ fontSize: "0.9em" }} />
            </span>
        </Tooltip>
    );
};
